/**
 * GroupNotesList Component
 *
 * Displays group notes list with the modern design pattern.
 * Uses the shared NotesListPage component with group-specific configuration.
 */

import React from 'react';
import { useUserState } from '@features/user';
import { NotesListPage } from '@features/notes';

export const GroupNotesList: React.FC = () => {
  const userState = useUserState();
  const groupId = userState?.group_ids?.[0];

  return (
    <NotesListPage
      groupId={groupId}
      title="Group Notes"
      showIssuingUser={true}
      enableDateFilter={false}
    />
  );
};
